import {
	connect
} from 'react-redux'
import FittingComponent from '../components/FittingComponent.jsx';
import {
	changeFittingOrderId, 
	findAllOrderIds, 
	changeFittingEventKey,
	findFittingDashboard, 
	findFittingList,
	findDetailsNeedBespoke,
	findNoLabelGeneratedCount,
	findFittingBatchList,
	findSerialNoData
} from '../actions';

const mapStateToProps = (state) => ({
	orderId: state.getIn(['fittingReducer', 'orderId']),
	allOrderIds: state.getIn(['fittingReducer', 'allOrderIds']),
	eventKey: state.getIn(['fittingReducer', 'eventKey']),
	activePage: state.getIn(['fittingListReducer', 'activePage']),
	itemPerPage: state.getIn(['fittingListReducer', 'itemPerPage']),
	roles: state.getIn(['authReducer', 'roles'])
})

const mapDispatchToProps = (dispatch) => ({
	changeOrderId: (payload) => {
		dispatch(changeFittingOrderId(payload));
	},
	changeEventKey: (key) => {
		dispatch(changeFittingEventKey(key));
	},
	findAllOrderIds: () => {
		dispatch(findAllOrderIds());
	},
	findFittingDashboard: (payload) => {
		dispatch(findFittingDashboard(payload));
	},
	findFittingList: (payload) => {
		dispatch(findFittingList(payload, {activePage:1, itemPerPage:10}));
	},	
	findDetailsNeedBespoke: (payload) => {
		dispatch(findDetailsNeedBespoke(payload));
	},
	findNoLabelGeneratedCount: (payload) => {
		dispatch(findNoLabelGeneratedCount(payload));
	},
	findFittingBatchList: (payload) => {
		dispatch(findFittingBatchList(payload, {activePage:1, itemPerPage:10}));
	},
	findSerialNoData: (payload) => {
		dispatch(findSerialNoData(payload));
	},
})

const FittingContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(FittingComponent)

export default FittingContainer;


// WEBPACK FOOTER //
// ./src/containers/FittingContainer.jsx